import React from "react";
import { Image } from "@wss/image";
type BlogFooterBottomSectionBoxesProps = {
  bgColor: string;
  bgColorHover: string;
  heading: string;
  href: string;
  linkTitle: string;
  src: string;
  text: string;
};
const sharedTextStyles = "font-normal leading-[18px] text-base";
const BlogFooterBottomSectionBoxes = ({
  bgColor,
  bgColorHover,
  heading,
  href,
  linkTitle,
  src,
  text
}: BlogFooterBottomSectionBoxesProps) => {
  return <a className={`${bgColor} ${bgColorHover} flex gap-x-4 h-[139px] items-center px-3 py-6 !w-full md:px-4 xl:w-64`} href={href} data-sentry-component="BlogFooterBottomSectionBoxes" data-sentry-source-file="BlogFooterBottomSectionBoxes.tsx">
      <Image className="h-16 w-[68px]" alt="" src={src} height={114} width={114} data-sentry-element="Image" data-sentry-source-file="BlogFooterBottomSectionBoxes.tsx" />
      <div className="flex flex-col xl:w-[252px]">
        <h4 className="font-bold leading-6 mb-1 p-0 text-white text-2xl">
          {heading}
        </h4>
        <p className={`${sharedTextStyles} mb-2 md:mb-1 text-base text-white`}>
          {text}
        </p>
        <p className={`${sharedTextStyles} underline underline-offset-2`} style={{
        color: "white"
      }}>
          {linkTitle}
        </p>
      </div>
    </a>;
};
export default BlogFooterBottomSectionBoxes;